import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../api";
export default function SearchPage() {

  const [searchParams] = useSearchParams();
  const q = searchParams.get("q") || "";

  const [users,setUsers] = useState([]);

  useEffect(() => {
  if (!q) return;

  api.get(`/users/search?q=${encodeURIComponent(q)}`)
    .then(r => setUsers(r.data.users || []))
    .catch(e => console.error(e));

}, [q]);

  return (
  <>
    
    <div className="ui-page">

      <h3>Search results for "{q}"</h3>
      
      {users.length === 0 && q && (
        <div className="ui-empty">
          No users found
        </div>
      )}

      {users.map(u=>(
        <Link
          key={u.id}
          to={`/u/${u.user_id}`}
          className="ui-list-row"
        >
          <img
            src={u.profile_pic_url || "/default-avatar.png"}
            alt=""
            className="ui-avatar"
          />

          <div>
            <div>{u.username}</div>
            <div className="ui-muted">
              @{u.user_id}
            </div>
          </div>
        </Link>
      ))}

    </div>

  </>
);
}